var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#D3D3D3",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.019 6c-1.3 0-2.503.413-3.484 1.112 1.512 1.078 1.512 8.573 0 9.65a5.982 5.982 0 003.484 1.113c3.303 0 5.981-2.658 5.981-5.938C27 8.658 24.322 6 21.019 6",
    fill: "#F59D1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.465 7.112A5.982 5.982 0 0013.98 6C10.678 6 8 8.658 8 11.937c0 3.28 2.678 5.938 5.981 5.938 1.3 0 2.503-.413 3.484-1.112-1.512-1.078-1.512-8.573 0-9.65",
    fill: "#E91D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875 11.937c0-1.957-.937-3.689-2.375-4.75a5.887 5.887 0 00-2.375 4.75c0 1.958.937 3.69 2.375 4.75a5.887 5.887 0 002.375-4.75",
    fill: "#F06122"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.01a805746ab519386dbd5e0ed6550b07.svg";
export { ForwardRef as ReactComponent };